import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Button,
  Modal,
} from "reactstrap";

import SweetAlert from "react-bootstrap-sweetalert";

import { PDFViewer } from "@react-pdf/renderer";

// Redux
import { connect, useSelector, useDispatch } from "react-redux";
import { withRouter, Link, useHistory, useParams } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import Loader from "../../components/Common/Loader";

//Action

import { casosUpdate, casosFilter } from "../../store/casos/actions";
import { casosDetallesFilter } from "../../store/actions";

import { grupotecnicoList } from "../../store/grupoTecnico/actions";
import { contactsFulllist } from "../../store/contacts/actions";

import DocuPDF from "./components/DocuPDF";
import styles from "./styles/Casos.module.scss";
import CasosEditComponent from "./components/CasosEditComponent";

import ComponentMantenimiento from "../../components/Common/ComponentsMantenimiento";
const CasosEdit = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const param = useParams();
  const str = param.id;
  const casosId = Number(str);
  const user = JSON.parse(localStorage.getItem("user"));
  const groups = String(user.groups);
  console.log(groups);
  useEffect(() => {
    dispatch(grupotecnicoList());

    dispatch(contactsFulllist());
    dispatch(casosFilter(`${casosId}/`));
    dispatch(casosDetallesFilter(`get_gestiones_caso/?caso=${casosId}`));
  }, [dispatch, casosId]);

  const casoDetallado = useSelector((state) => state.Casos.casos);
  const casoDetalles = useSelector(
    (state) => state.CasosDetalles.casosDetalles
  );
  console.log(casoDetalles);
  const contact = useSelector((state) => state.Contacts.contacts) || [];
  const grupotTecnico =
    useSelector((state) => state.GrupoTecnico.grupotecnico.results) || [];
  const [selectedGrupoTecnico, setSelectedGrupoTecnico] = useState(null);

  function handleSelectGrupoTecnico(selectedGrupoTecnico) {
    setSelectedGrupoTecnico(selectedGrupoTecnico.value);
  }

  const grupoTecnicoFilter = Array.isArray(grupotTecnico)
    ? grupotTecnico.filter(
        (item) => item.nombre === casoDetallado.grupo_tecnico
      )
    : [];

  const grupoTecnicoFilter1 =
    grupotTecnico &&
    grupotTecnico.filter((item) => item.nombre === casoDetallado.grupo_tecnico);

  const grupo_tecnico = selectedGrupoTecnico
    ? selectedGrupoTecnico
    : grupoTecnicoFilter[0] && grupoTecnicoFilter[0].id;

  const sd = Array.isArray(contact)
    ? contact.filter((item) => item.grupo_tecnico === grupo_tecnico)
    : [];

  const prueba = casoDetallado.tecnico_asignado;

  const filteredtest = sd?.filter((item) =>
    prueba?.some((names) => names.includes(item.first_name))
  );

  const [fechacalendario, setFechaAsignada] = useState(null);

  const [horaEntrada, setHoraEntrada] = useState(null);

  const [horaSalida, setHoraSalida] = useState(null);

  const fechaCasos = casoDetallado.fecha_asignacion;

  const fecha_asignacion =
    fechacalendario === null ? fechaCasos : fechacalendario;

  let lapso_hora_entrada = "";
  let lapso_hora_salida = "";
  let horaEntraRec = horaEntrada?.toString().slice(0, 5);
  lapso_hora_entrada = horaEntraRec;
  let horaSalidaRec = horaSalida?.toString().slice(0, 5);
  lapso_hora_salida = horaSalidaRec;

  const onChangeFecha = (e) => {
    setFechaAsignada(e.target.value);
  };

  const onChangeHoraEntrada = (e) => {
    if (e && e.target && e.target.value) {
      setHoraEntrada(e.target.value);
    }
  };

  const onChangeHoraSalida = (e) => {
    if (e && e.target && e.target.value) {
      setHoraSalida(e.target.value);
    }
  };

  const [formData, setFormData] = useState({
    tecnico_asignado: [],
    tipo_visita: "",
    tipo_servicio: "",
    observaciones_adicionales: "",
    datosServicio: casoDetallado.datosServicio,
  });

  const {
    tecnico_asignado,
    tipo_visita,
    tipo_servicio,
    datosServicio,
    observaciones_adicionales,
  } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const data = {
      fecha_asignacion,

      lapso_hora_entrada,
      lapso_hora_salida,
      grupo_tecnico,
      estatus: "",
      tipo_visita,
      tipo_servicio,
      datosServicio,
      observaciones_adicionales,
    };

    if (tecnico_asignado.length > 0) {
      data.tecnico_asignado = tecnico_asignado;
    }

    props.casosUpdate(casosId, data);
  };

  const [verPDF, setVerPDF] = useState(false);
  const [caso_txt, setCaso_txt] = useState("");

  const Menu = () => (
    <Button
      variant="dark"
      onClick={() => {
        setVerPDF(!verPDF);
      }}
    >
      {verPDF ? "Ocultar PDF" : "Ver PDF"}
    </Button>
  );

  const redirect = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <ComponentMantenimiento caso_txt={caso_txt}></ComponentMantenimiento>
      <div className="page-content">
        <MetaTags>
          <title> Editar Casos</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumb breadcrumbItem={"Casos"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              {props.casosUpdated.id ? (
                <SweetAlert
                  title="Hecho!"
                  success
                  timeout={1000}
                  showConfirm={false}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  Se actualizado el caso
                </SweetAlert>
              ) : null}
              <h1>Caso # {casoDetallado.id}</h1>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={7}>
                      <Link
                        className="btn btn-primary waves-effect waves-light"
                        to={`/Informes/${casosId}`}
                      >
                        Ver Informes{" "}
                      </Link>
                      <Link
                        className="btn btn-success waves-effect waves-light m-1"
                        to={`/cotizacion/${casosId}`}
                      >
                        Ver Cotizaciones{" "}
                      </Link>
                      <Link
                        className="btn btn-info waves-effect waves-light m-1"
                        to={`/casos/${casosId}/CasosDetalles`}
                      >
                        Ver Gestiones{" "}
                      </Link>
                      <button
                        className="btn btn-primary waves-effect waves-light"
                        onClick={redirect}
                      >
                        Ir a Atras
                      </button>

                      <Link
                        className="btn btn-primary waves-effect waves-light m-1"
                        to={`/casos`}
                      >
                        Volver a Casos{" "}
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Row className="justify-content-center">
                <Form
                  className="d-flex flex-column justify-content-center h-custom-2 w-75 pt-3 ps-5"
                  onSubmit={onSubmit}
                >
                  <CasosEditComponent
                    contact={contact}
                    casoDetallado={casoDetallado}
                    groups={groups}
                    handleSelectGrupoTecnico={handleSelectGrupoTecnico}
                    grupoTecnicoFilter1={grupoTecnicoFilter1}
                    grupotTecnico={grupotTecnico}
                    filteredtest={filteredtest}
                    sd={sd}
                    setFormData={setFormData}
                    formData={formData}
                    onChangeFecha={onChangeFecha}
                    onChangeHoraEntrada={onChangeHoraEntrada}
                    onChangeHoraSalida={onChangeHoraSalida}
                    onChange={onChange}
                    casoDetalles={casoDetalles}
                  ></CasosEditComponent>

                  <Row className="col-lg-12 justify-content-center">
                    {casoDetallado.estatus !== "FINALIZAR" ||
                    groups === "SuperAdmin" ||
                    groups === "Supervisor" ? (
                      <Col md={1} className="mx-3">
                        <Button
                          color="primary"
                          type="submit"
                          disabled={
                            casoDetallado.estatus === "FINALIZAR"
                              ? true
                              : groups === "SuperAdmin" ||
                                groups === "Supervisor"
                                || groups === "INGENIERO"
                              ? false
                              : true
                          }
                        >
                          Enviar
                        </Button>
                      </Col>
                    ) : null}

                    <Col md={1} className="mx-1">
                      <button
                        className="btn btn-primary waves-effect waves-light"
                        onClick={redirect}
                        type="button"
                      >
                        Volver
                      </button>
                    </Col>

                    <Col md={1} className="mx-1">
                      <Menu />
                    </Col>
                    {verPDF ? (
                      <Modal
                        isOpen={verPDF}
                        centered={true}
                        toggle={() => {
                          setCaso_txt("");
                          setVerPDF(false);
                        }}
                        size="xl"
                      >
                        <div className="modal-header">
                          <PDFViewer style={{ width: "85%", height: "100vh" }}>
                            <DocuPDF caso={casoDetallado} />
                          </PDFViewer>
                          <button
                            type="button"
                            onClick={() => {
                              setCaso_txt("");
                              setVerPDF(false);
                            }}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            style={{ backgroundColor: "white" }}
                          >
                            <span
                              aria-hidden="true"
                              className={`${styles.spanGrande}`}
                            >
                              ×
                            </span>
                          </button>
                        </div>
                      </Modal>
                    ) : null}
                  </Row>
                </Form>
              </Row>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, casos, casosUpdated } = state.Casos;
  return { error, loading, casos, casosUpdated };
};

CasosEdit.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  casosUpdated: PropTypes.object,
};

export default withRouter(connect(mapStateToProps, { casosUpdate })(CasosEdit));
